/**
 * @name v0.0.6版本过渡
 * @params { Object } formData 表单数据
 * @returns { Object } 过渡之后的数据
 * @author liuguisheng
 * @version 2010-1-1
 * 
*/
// 导入v0.0.5数据格式
import * as v005 from './v005.js';

export const upgrade = function ( formData ) {
    // 取出当前版本
    let { version } = formData;
    /** 
     * 如果当前版本为v0.0.6,则该数据不需要更新直接抛出,
     * 否则先将数据格式化为v0.0.5数据在进行处理
     *
    **/
    if ( version == '0.0.6') return formData;
    // 把数据按照v005版本格式化数据，然后在进行处理
    let currentData = v005.upgrade(formData);
    // 取出表单项字典,给需要添加showRule(显示设置)配置的表单项添加该配置
    let { formMap={} } = currentData;
    // 需要添加showRule配置的组件类型列表
    let includeShowRule = ['text','input','textarea','radio','checkbox','select','switch','datePicker','timePicker','uploadImage','uploadFile'];
    // 添加配置
    for ( let key in formMap) {
        let { type } = formMap[key].node;
        includeShowRule.includes(type) && (formMap[key].renderOption.showRule = 'all');
    }
    // 版本号更新
    currentData.version = '0.0.6';
    return currentData;
}



// WEBPACK FOOTER //
// ./src/assets/version/v006.js